import { CompetitorVsPage } from '../../components/comparisons/CompetitorVsPage';
import { getCompetitorComparison } from '../../data/competitor-comparisons';
import { COMPETITOR_PRICING, COMPETITOR_PRICING_MAX_AGE_DAYS } from '../../data/competitor-pricing';
import { warnStaleEntries } from '../../data/pseo/staleness';
import { isPublishable } from '../../data/pseo/types';

const entry = getCompetitorComparison('dropbox-replay-vs-frame-io');

export default function DropboxReplayVsFrameIoPage() {
  return (
    <CompetitorVsPage
      entry={entry}
      documentTitle="Dropbox Replay vs Frame.io (2026) Compared"
      metaDescription="Dropbox Replay vs Frame.io compared: file types, NLE integrations, guest review, approvals, add-on vs per-member pricing and free access."
      h1="Dropbox Replay vs Frame.io"
      heroText="Review inside Dropbox against a standalone video review tool, compared on official facts."
      publishDate="2026-10-22 00:00"
      readTimeMinutes="7"
      coverSrc="https://a.storyblok.com/f/287637539865613/2250x750/8d83a78aaf/best-video-review-platforms-for-creative-teams-in-2026.png"
      coverAlt="Dropbox Replay vs Frame.io comparison"
    />
  );
}

export function getStaticProps() {
  warnStaleEntries('competitor-comparisons', [entry], COMPETITOR_PRICING_MAX_AGE_DAYS);
  warnStaleEntries(
    'competitor-pricing',
    COMPETITOR_PRICING.filter((pricing) => pricing.id === entry.a || pricing.id === entry.b),
    COMPETITOR_PRICING_MAX_AGE_DAYS,
  );
  if (!isPublishable(entry)) {
    return { notFound: true };
  }
  return { props: {} };
}
